import { useQuery } from '@tanstack/react-query'
import { getJwt } from '@/shared/lib/betterAuth/get-jwt'
import { getBanks } from '@/services/banks.services'
import {
  PAYMENT_QUERY_KEYS,
  CACHE_STALE_TIME,
  CACHE_GC_TIME,
  QUERY_NETWORK_MODE,
} from '@/shared/constants/cache'
import type { BankInfo } from '@/shared/types/global.types'

export function useBanks(enabled: boolean = true) {
  return useQuery<BankInfo[]>({
    queryKey: PAYMENT_QUERY_KEYS.banks,
    queryFn: async () => {
      const token = await getJwt()
      if (!token) throw new Error('No JWT token')
      return getBanks(token)
    },
    enabled,
    staleTime: CACHE_STALE_TIME,
    gcTime: CACHE_GC_TIME,
    networkMode: QUERY_NETWORK_MODE,
  })
}
